<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-table :data="bedList" border style="width: 100%">
			<el-table-column prop="deviceId" label="设备号">
			</el-table-column>
			<el-table-column prop="mac" label="设备mac号">
			</el-table-column>
			<el-table-column prop="version" label="信号强度">
			</el-table-column>
			<el-table-column prop="version" label="设备版本">
			</el-table-column>
			<el-table-column prop="createTime" label="时间">
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="info" @click="handleTime( scope.row)" icon="el-icon-odometer">实时</el-button>
					<el-button size="mini" type="success" @click="handleReport(scope.row)" icon="el-icon-document">报告</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog title="查看报告" :visible.sync="look_dv" width="95%">
			<div class="device">
				<span>mac :</span>
				<span>{{device}}</span>
			</div>
			<look-report :dialogReport="reportList"></look-report>
		</el-dialog>
	</div>
</template>

<script>
	import mybread from "@/components/bread"
	import lookReport from "./operate/report.vue"
	export default {
		components: {
			mybread,
			lookReport
		},
		inject: ['reload'],
		data() {
			return {
				bedList: [],
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				look_dv: false,
				reportList: [],
				total1: 0,
				pageSize1: 10,
				currentPage1: 1,
				device: "",
				list_loading:true
			}
		},
		created() {
			this.getBedList()
			this.device = window.localStorage.getItem("device")
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getBedList();
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getBedList();
			},
			getBedList() {
				const data = {
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize
				}
				this.$get("api/deviceList", data).then(res => {
					window.console.log(res)
					this.bedList = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
				}).catch((e) => {
					window.console.log(e)
				})
			},
			handleReport(row) { //报告
				window.console.log(row)
				this.look_dv = true
				window.localStorage.setItem("device", row.mac)
			},
			handleTime(row) { //实时
			window.localStorage.setItem("deviceTime", row.mac)
				let Logistics = this.$router.resolve({
					path: '/real-time',
					query: {
						mac: row.mac
					}
				})
				window.open(Logistics.href, '_blank');
			}


		},
	}
</script>

<style scoped="scoped">
	.block {
		text-align: center;
		margin-top: 20px;
	}

	.main {
		background: #fff;
		padding: 0 20px 20px 20px;
	}
	.device{
		position: absolute;
		top:24px;
		left:120px;
		font-size:13px;
		display: flex;
		align-items: center;
	}
	.device span:nth-of-type(2){
		margin-left:6px;
	}
</style>
